import { getAPIBlob } from "../helpers/httpHelper";
import { API_ADMIN_ARBOL_CAUSAL, URL_SUPPORT } from "../helpers/variableHelper";

export default class ArbolCausalService {
    public static async GetDocumento(token: string){
        getAPIBlob(`${URL_SUPPORT}${API_ADMIN_ARBOL_CAUSAL}/Arbol Causal.xlsx`, { Authorization: `Bearer ${token}` }).then(r => {
            console.log(r);
            console.log("Resultado");
            let file = r.result;
            let fileURL = URL.createObjectURL(file);
            let fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.download = "Arbol Causal.xlsx";
            fileLink.click();
        }).catch(e=>{console.log(e)});
    }
}